import React from 'react'
import { Trans, WithTranslation } from 'react-i18next'
import { FiUser } from 'react-icons/fi'
import Flex from 'typescript-styled-flex'
import {
  Label,
  Link,
  MenuElement,
} from '../../../../../components/Template/Sidebar'
import { IWithSize } from '../../../../BookingCalendar/Calendar/Calendar'
import { Mixpanel } from '../../../../../utils/Mixpanel'
import { useSelector } from 'react-redux'
import { getUserId } from '../../../../../reducers/userAccount/selectors/userAccount'

function Clients({ size = 1 }: IWithSize & WithTranslation) {
  const userId = useSelector(getUserId)

  const trackClick = () => {
    Mixpanel.people.increment(userId, 'Clients Menu Opened', 1)
    Mixpanel.track('Clients Menu Item Used', {})
  }

  return (
    <MenuElement alignCenter={true} size={size}>
      <Link onClick={trackClick} to={'/clients'} size={size}>
        <Flex alignCenter={true}>
          <b>
            <FiUser size={16 * size} />
          </b>
          <Label primary={true} size={size}>
            <Trans i18nKey={'menu_clients'}>Klienci</Trans>
          </Label>
        </Flex>
      </Link>
    </MenuElement>
  )
}

export default Clients
